import React from 'react';

function About() {
    return (
        <div className='about'>
            <p>This site was developed simply as practice. It's based in the <a href='https://www.omdbapi.com/' target='_blank' rel='noreferrer'>OMDB API</a>, a large, open-access movie database. It was made by <a href='https://www.linkedin.com/in/santiagodovalb/' target='_blank' rel='noreferrer'>Santiago Doval</a>, powered by Node JS and React.</p>
            <p>---</p>
            <p>Este sitio fue desarrollado simplemente a modo de practica. Esta basado en la <a href='https://www.omdbapi.com/'>OMDB API</a>, una gran base de datos de peliculas de libre acceso. Fue realizado por <a href='https://www.linkedin.com/in/santiagodovalb/' target='_blank' rel='noreferrer'>Santiago Doval</a>, utilizando Node JS y React.</p>
        </div>
    )
}

export default About